import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from '@mui/material/styles';

import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import theme from './theme';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <ThemeProvider theme={theme}>
        <BrowserRouter>
            <SnackbarProvider>
                <AuthProvider>
                    <App />
                </AuthProvider>
            </SnackbarProvider>
        </BrowserRouter>
    </ThemeProvider>
);
